export const IconStarAlt = () => {
    return (
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.5 0C15.5347 0 17.3163 1.36532 17.8453 3.33005L19.0809 7.91914L23.6699 9.15475C25.6347 9.68375 27 11.4653 27 13.5C27 15.5347 25.6347 17.3163 23.6699 17.8453L19.0809 19.0809L17.8453 23.67C17.3163 25.6347 15.5347 27 13.5 27C11.4653 27 9.68375 25.6347 9.15475 23.67L7.91914 19.0809L3.33005 17.8453C1.36532 17.3163 0 15.5347 0 13.5C0 11.4653 1.36532 9.68375 3.33005 9.15475L7.91914 7.91914L9.15475 3.33005C9.68375 1.36532 11.4653 0 13.5 0Z"
                fill="currentColor"
            />
        </svg>
    );
};
